import React, { useLayoutEffect, useState } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { useSelector } from 'react-redux';

import {
    header,
    mobileNavList,
    mobileNavLink,
    mobileNavItem,
    mobileNav,
    linkActive,
    cart,
    hamburger,
    headerShopCart,
    navigation,
    scroll,
    clear,
    widgets,
    smokeBox,
} from './top-bar.module.scss';
import { mainGrid } from '../../style/grid.module.scss';
import HamburgerIconSVG from '../../assets/images/svg/icon-hamburger.svg';
import { selectUserData } from '../../redux/user/user.selectors';
import { getAbsolutePath } from '../../routes';
import { useSmokes } from '../../hooks/use-smokes';

import AccountWidget from '../molecules/account-widget';
import MainNavigation from '../molecules/main-navigation';
import CartWidget from '../molecules/cart/cart-widget';
import MobileNavPanel from './mobile-nav-panel';
import NestedNav from '../molecules/nested-nav';
import Logo from '../atoms/logo';
import Smoke from '../molecules/smoke';

const mainNavItems = [
    {
        absolutePath: '/',
        label: 'Home',
        key: 'HOME',
    },
    {
        absolutePath: '/o-nas/',
        label: 'O nas',
        key: 'ABOUT',
    },
    {
        label: 'Cennik',
        key: 'PRICING',
    },
    {
        absolutePath: '/sklep/',
        label: 'Sklep',
        key: 'SHOP',
    },
    {
        absolutePath: '/blog/',
        label: 'Blog',
        key: 'BLOG',
    },
    {
        absolutePath: '/faq/',
        label: 'FAQ',
        key: 'FAQ',
    },
    {
        absolutePath: '/kontakt/',
        label: 'Kontakt',
        key: 'CONTACT',
    },
];

const TopBar = ({ transparent, isShopCart = false, customColor = '' }) => {
    const { subscription } = useStaticQuery(query);
    const [scrolled, setScrolled] = useState(false);
    const [isMainNavOpen, setIsMainNavOpen] = useState(false);
    const isLogged = useSelector(selectUserData) !== null;

    const smokes = useSmokes();

    const logoUrl = isLogged ? getAbsolutePath('APP') : '/';

    const mainNavClasses = {
        nav: mobileNav,
        navList: mobileNavList,
        navItem: mobileNavItem,
        navLink: mobileNavLink,
        navLinkActive: linkActive,
    };

    const style = customColor ? { style: { backgroundColor: customColor } } : {};

    const navItems = mainNavItems.map((navItem) => {
        if (navItem.key === 'PRICING') {
            return {
                ...navItem,
                absolutePath: `/sklep/${subscription.slug}/`,
            };
        }
        return navItem;
    });

    useLayoutEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 0);

        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <>
            <header
                {...style}
                className={`
                    ${mainGrid}
                    ${header}
                    ${isShopCart ? headerShopCart : ''}
                    ${scrolled ? scroll : ''}
                    ${transparent ? clear : ''}
                `}
            >
                <Logo to={logoUrl} />
                {!isShopCart ? (
                    <>
                        <MainNavigation
                            navItems={!isShopCart ? navItems : []}
                            className={navigation}
                        />
                        <div className={widgets}>
                            <AccountWidget />
                            <CartWidget className={cart} />
                            <button className={hamburger} onClick={() => setIsMainNavOpen(true)}>
                                <HamburgerIconSVG />
                            </button>
                        </div>
                    </>
                ) : null}
                {(smokes.message.show || smokes.notification.show) && (
                    <div className={smokeBox}>
                        {smokes.notification.show && <Smoke {...smokes.notification.props} />}
                        {smokes.message.show && <Smoke {...smokes.message.props} />}
                    </div>
                )}
            </header>
            <MobileNavPanel open={isMainNavOpen} closeFunc={() => setIsMainNavOpen(false)}>
                <NestedNav
                    navItems={navItems}
                    classes={mainNavClasses}
                    onItemClick={() => setIsMainNavOpen(false)}
                    collapse={!isMainNavOpen}
                />
            </MobileNavPanel>
        </>
    );
};

const query = graphql`
    query {
        subscription: product(productId: { eq: 1 }) {
            slug
        }
    }
`;

export default TopBar;
